function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import * as React from 'react';

function StarFilledHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 32"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#dedafa",
    d: "M24.727 31.564c-.436 0-.873-.145-1.309-.291l-6.545-3.636c-.145-.145-.291-.145-.582 0L9.6 31.273c-.727.436-1.891.436-2.764-.145s-1.164-1.6-1.018-2.473L7.127 20.8c0-.145 0-.291-.145-.436l-5.673-5.818c-.727-.727-.873-1.745-.582-2.618s1.018-1.6 2.036-1.745l7.709-1.164c.145 0 .291-.145.436-.291l3.345-6.982C14.689.873 15.562.291 16.58.291s1.891.582 2.327 1.455l3.491 6.982c.145.145.291.291.436.291l7.564 1.164c1.018.145 1.745.873 2.036 1.745s.145 1.891-.582 2.618l-5.673 5.673c-.145.145-.145.291-.145.436l1.309 7.855c.145 1.018-.291 2.036-1.018 2.473-.436.436-1.018.582-1.6.582z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c50bb",
    d: "M16.582.291v27.2h-.291L9.6 31.127c-.727.436-1.891.436-2.764-.145-.873-.436-1.164-1.455-1.018-2.473l1.309-7.855c0-.145 0-.291-.145-.436l-5.673-5.673C.582 13.818.436 12.8.727 11.927s1.018-1.6 2.036-1.745l7.709-1.164c.145 0 .291-.145.436-.291l3.345-6.982C14.544.872 15.562.29 16.58.29z"
  }));
}

export default StarFilledHalf;